import { Link } from "react-router-dom";
import { G21Stacked } from "./G21Monogram";
import { CookieSettingsButton } from "@/components/CookieBanner";
import { useT } from "@/i18n/LanguageProvider";

export const Footer = ({ company }) => {
    const t = useT();
    const year = new Date().getFullYear();
    return (
        <footer className="bg-cream border-t border-stone-200" data-testid="footer">
            <div className="container-page py-16">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="text-ink">
                            <G21Stacked size={86} className="text-ink" />
                        </div>
                        <p className="font-body text-sm text-stone-600 mt-5 max-w-md leading-relaxed">
                            {t({
                                de: "Ein modernes Wohnensemble mit vier hochwertigen Eigentumswohnungen – energieeffizient, ruhig gelegen, in Wiesbaden-Biebrich.",
                                en: "A modern residential ensemble with four high-quality condominiums – energy-efficient, quietly located in Wiesbaden-Biebrich.",
                            })}
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="overline mb-4">{t({ de: "Bauträger", en: "Developer" })}</h4>
                        <ul className="space-y-2 font-body text-sm text-stone-700">
                            <li>{company?.name || "G21 Projektentwicklung"}</li>
                            <li>{company?.address || "Gaugasse 21, 65203 Wiesbaden"}</li>
                            <li>
                                <a href={`tel:${(company?.phone || "").replace(/\s/g, "")}`} className="hover:text-brand-600">
                                    {company?.phone}
                                </a>
                            </li>
                            <li>
                                <a href={`mailto:${company?.email}`} className="hover:text-brand-600">
                                    {company?.email}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="overline mb-4">{t({ de: "Rechtliches", en: "Legal" })}</h4>
                        <ul className="space-y-2 font-body text-sm">
                            <li>
                                <Link to="/impressum" className="text-stone-700 hover:text-brand-600" data-testid="footer-impressum">
                                    {t({ de: "Impressum", en: "Imprint" })}
                                </Link>
                            </li>
                            <li>
                                <Link to="/datenschutz" className="text-stone-700 hover:text-brand-600" data-testid="footer-datenschutz">
                                    {t({ de: "Datenschutz", en: "Privacy" })}
                                </Link>
                            </li>
                            <li>
                                <CookieSettingsButton className="text-stone-700" />
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <h4 className="overline mb-4">{t({ de: "Intern", en: "Internal" })}</h4>
                        <ul className="space-y-2 font-body text-sm">
                            <li>
                                <Link to="/admin/login" className="text-stone-700 hover:text-brand-600" data-testid="footer-admin">
                                    {t({ de: "Admin-Login", en: "Admin login" })}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-stone-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <p className="font-body text-xs text-stone-500">
                        © {year} {company?.name || "G21 Projektentwicklung"}.{" "}
                        {t({ de: "Alle Rechte vorbehalten.", en: "All rights reserved." })}
                    </p>
                    <p className="font-body text-xs text-stone-500">
                        {t({
                            de: "Visualisierungen können von der Ausführung abweichen. Inventar nicht inbegriffen.",
                            en: "Visualisations may differ from the final build. Furniture not included.",
                        })}
                    </p>
                </div>
            </div>
        </footer>
    );
};
